import ReactOnRails from 'react-on-rails';
import React from 'react';
import Detail from '@Pages/Detail/pc/index';
import DetailSp from '@Pages/Detail/sp/index';

// Detail/DetailSpのeager registration本体（PR #2082）。
//
// 現状はserver-bundle.jsだけがこのモジュールをimportし、application.js側の
// lazy+Suspense登録をSSR時にだけ後勝ちで上書きする形で使う（既知の罠14）。
//
// prerender: trueを有効化する次期PRでは、Detailページ専用のeagerなクライアント
// エントリ（例: packs/detail.js）を新設し、application.jsの代わりにこのモジュールを
// importさせる想定（PR #2082 Point1、fableモデルによる設計比較で決定）。これにより
// クライアント側のhydrate時も常にeager登録された状態になり、React 17 legacy modeの
// `ReactDOM.hydrate`がsuspendしたSuspense境界をhydrateできず全体をCSRへフォール
// バックする問題（dandeizumiのレビュー指摘）を、他ページのコード分割を一切崩さずに
// 解消できる。詳細な比較・却下案の理由はPR #2082本文を参照。
//
// railsContext（第2引数）からリクエストパスを受け取りcurrentPathとして渡す。SSR時に
// ヘッダーの「選択中」ナビ判定（getPathResolver）を正しく行うためのprop
// （詳細はComponents/pathresolver/index.tsのコメント参照）。
ReactOnRails.register({
    Detail: (props, railsContext) => {
        return <Detail {...props} currentPath={railsContext?.pathname} />;
    },
    DetailSp: (props, railsContext) => {
        return <DetailSp {...props} currentPath={railsContext?.pathname} />;
    },
});
